import gql from 'graphql-tag'
import api from '../apiClient'

export default {
  readLink: (link, consecutivo) =>
    api
      .send({
        query: gql`
          query readLink($link: String!, $consecutivo: Int!) {
            Link {
              readLink(link: $link, consecutivo: $consecutivo) {
                _id
                state
                factura {
                  _id
                  documento {
                    value
                  }
                  emisor {
                    id
                  }
                  consecutivo
                  receptor {
                    id
                    nombre
                    correoElectronico
                    identificacion {
                      tipo {
                        id
                      }
                      numero
                    }
                  }
                  detalleServicio {
                    lineaDetalle {
                      numeroLinea
                      cantidad
                      detalle
                      precioUnitario
                      montoTotalLinea
                    }
                  }
                  resumenFactura {
                    codigoTipoMoneda {
                      codigoMoneda {
                        id
                        value
                        simbolo
                      }
                      tipoCambio
                    }
                    totalVentaNeta
                    totalImpuesto
                    totalComprobante
                  }
                }
              }
            }
          }
        `,
        variables: {
          link,
          consecutivo
        }
      })
      .then(result => result.data.data.Link.readLink),

  create: input =>
    api
      .send({
        query: gql`
          mutation create($input: LinkInput!) {
            Link {
              create(input: $input)
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.Link.create),

  setLinkState: (_id, state) =>
    api
      .send({
        query: gql`
          mutation setLinkState($_id: ID!, $state: String!) {
            Link {
              setLinkState(_id: $_id, state: $state)
            }
          }
        `,
        variables: {
          _id,
          state
        }
      })
      .then(result => result.data.data.Link.setLinkState),

  readLinksByEmisor: (emisor, cursor, limit = 10, filter = null) =>
    api
      .send({
        query: gql`
          query readLinksByEmisor($emisor: ID!, $cursor: String, $limit: Int, $filter: Filter) {
            Link {
              readLinksByEmisor(emisor: $emisor, cursor: $cursor, limit: $limit, filter: $filter) {
                feed {
                  _id
                  _idFactura
                  consecutivo
                  url
                  state
                  cliente

                  createdAt
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          cursor,
          limit,
          filter
        }
      })
      .then(result => result.data.data.Link.readLinksByEmisor)
}
